import { UserStub } from "api/common/types/auth.types";
import { TDateISO } from "api/common/types/datetime.types";
import { valueof } from "api/common/utils/type.utils";

import { ProductStub } from "../product/product.types";

export const MAINTENANCE_STATUSES = {
  REQUESTED: "Requested",
  RELEASED: "Released",
  PENDING: "Pending",
  APPROVED: "Approved",
  INITIATED: "Initiated",
  DRAFT: "Draft",
  REJECTED: "Rejected",
  IN_ASSURANCE_MAINTENANCE: "In Assurance Maintenance",
  TERMINATED: "Terminated",
} as const;
export type MaintenanceStatus = valueof<typeof MAINTENANCE_STATUSES>;

/**
 * Utility function to get the user-facing display text for a maintenance status
 * This allows us to show "Denied" instead of "Terminated" without changing the backend
 */
export const getMaintenanceStatusDisplay = (
  status: MaintenanceStatus,
): string => {
  if (status === MAINTENANCE_STATUSES.TERMINATED) {
    return "Denied";
  }
  return status;
};

export const ValidationTeamAssignmentStatuses = {
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
} as const;
export type ValidationTeamAssignmentStatus = valueof<
  typeof ValidationTeamAssignmentStatuses
>;

export interface MaintenanceStub {
  maintenance_id: number;
  title: string;
  product?: { product_id: number };
}

export interface Maintenance {
  maintenance_id: number;
  title: string;
  product: ProductStub;
  status: MaintenanceStatus;
  lab_request: UserStub | null;
  vendor_request: UserStub | null;
  team_due_date: TDateISO | null;
  acmr_due_date: TDateISO | null;
  vendor_request_date: TDateISO | null;
  lab_request_date: TDateISO | null;
  validation_team_approval_status: ValidationTeamAssignmentStatus | null;
  rejection_rationale: string | null;
  completion_date: TDateISO;
  entrydate: TDateISO;
  validator_approval_date: TDateISO | null;
  iar_received: TDateISO;
  certification_date: TDateISO | null;
  niap_approval_date: TDateISO | null;
}
